import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e087f846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }



export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitle',
  props: {
	text: {
		type: String,
		default: () => "",
	},
	backgroundImageClass: {
		type: String,
		default: () => "",
	},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`title-wrapper`, __props.backgroundImageClass])
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(__props.text), 1),
    _renderSlot(_ctx.$slots, "main-action")
  ], 2))
}
}

})